/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */
import { Children } from 'react';
import { gql, useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { DEFAULT_LOCALE } from '../i18n';

const TranslationsQuery = gql`
  query TranslationsQuery($locale: Language!, $keys: [String]) {
    translations(language: $locale, keys: $keys, section: "checkout") {
      key
      value
    }
  }
`;

const createTranslationMap = (translations) => {
  const messages = {};

  if (translations) {
    translations.forEach(({ key, value }) => {
      messages[key] = value;
    });
  }
  return messages;
};

const LanguageProvider = ({ locale, keys, children }) => {
  const { data: { translations } = {}, loading } = useQuery(TranslationsQuery, {
    variables: { locale, keys },
  });

  if (loading) {
    return null;
  }

  return (
    <IntlProvider
      locale={locale}
      key={locale}
      messages={createTranslationMap(translations)}
      // To facilitate migration from react-intl v2
      textComponent="span"
    >
      {Children.only(children)}
    </IntlProvider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.element.isRequired,
  locale: PropTypes.string,
  keys: PropTypes.arrayOf(PropTypes.string),
};

LanguageProvider.defaultProps = {
  locale: DEFAULT_LOCALE,
  keys: null,
};

export default LanguageProvider;
